import React, { useEffect, useRef, InputHTMLAttributes, useState } from 'react';
import { useField } from '@unform/core';
import { Container } from './styles';
import theme from '../../../../../../styles/ThemeComponents';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  style?: Record<string, any>;
  name: string;
  unique?: boolean;
  preText?: JSX.Element;
  posText?: JSX.Element;
  background_line?: string;
  options: {
    id: string;
    value: string;
    label: string;
    sub_title?: string;
  }[];
}
const CheckboxInput: React.FC<Props> = ({
  name,
  options,
  preText = '',
  posText = '',
  unique = false,
  style,
  background_line = '',
  ...rest
}) => {
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const { fieldName, registerField, defaultValue = [] } = useField(name);

  const [value, setValue] = useState<Array<string>>([]);


  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs.current,
      getValue: (refs: HTMLInputElement[]) => {
        return value;
      },
      
      setValue: (refs: HTMLInputElement[], values: string[]) => {
        setValue( typeof values === 'string' ? [values] : values)
      },
    });
  }, [defaultValue, fieldName, registerField]);
  return (
    <Container style={style} {...rest}>
      {preText && <label style={{ border: '0', textAlign: 'justify', color: theme.color }}>{preText}</label>}
      {options.map((option, index) => (
        <label style={{ cursor: 'pointer', color: theme.color, width: '100%', background: background_line ? background_line : '#eee', padding: "5px", margin: '5px 0px' }} htmlFor={`${name}_${option.id}`} key={`${name}_${option.id}`}>
          <input style={{ minWidth:'20px', color: theme.color, border: '1px solid#333' }}
            onClick={() => {
              if (unique) {
               if(value?.[0] === option?.value){
                setValue([])
               }
               else{
setValue([option?.value])
               }
                
              }
              else{

                let newValue = [...value];
                if(newValue?.findIndex( i => i === option?.value) >= 0){
newValue = newValue?.filter( i => i !== option?.value)

                }
                else{
                  newValue.push(option?.value)
                }

                setValue(newValue)
              }
            }}
           checked={ value?.findIndex( i => i === option?.value) >= 0}
            ref={ref => {
              inputRefs.current[index] = ref as HTMLInputElement;
            }}
            value={option.value}
            type="checkbox"
            id={`${name}_${option.id}`}
            {...rest}
          />
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', marginLeft: '10px' }}>
            <p style={{ color: theme.color, fontSize: '12px' }}>{option.label}</p>
            {option.sub_title && <p style={{ color: theme.color, fontSize: '12px' }}>{option.sub_title}</p>}
          </div>
        </label>
      ))}
      {posText && <label style={{ border: '0', textAlign: 'justify', color: theme.color }}>{posText}</label>}
    </Container>
  );
};
export default CheckboxInput;
